import React, { useState } from "react";

const Accordion = ({ items }) => {
  const [activeIndex, setActiveIndex] = useState(null);

  const onAccordionClick = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  return (
    <div className="hs-accordion-group">
      {items.map((item, index) => (
        <div
          className={`hs-accordion ${activeIndex === index ? "active" : ""}`}
          key={index}
        >
          <button
            className={`hs-accordion-toggle ${
              activeIndex === index ? "hs-accordion-active:text-blue-600" : ""
            } group py-3 inline-flex items-center gap-x-3 w-full font-semibold text-left text-gray-800 transition hover:text-gray-500 dark:text-gray-200 dark:hover:text-gray-400`}
            onClick={() => onAccordionClick(index)}
            aria-controls={`hs-basic-collapse-${index}`}
          >
            {item.title}
          </button>
          <div
            id={`hs-basic-collapse-${index}`}
            className={`hs-accordion-content ${
              activeIndex === index
                ? "w-full overflow-hidden transition-[height] duration-300"
                : "hidden"
            }`}
            aria-labelledby={`hs-basic-heading-${index}`}
          >
            <p className="text-gray-800 dark:text-gray-200">{item.content}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Accordion;
